module.exports = __webpack_public_path__ + "static/media/Paqtana-Logo-Solo.e7dfeb51.svg";